module.exports = __webpack_public_path__ + "static/media/img4.bc6d716a.jpg";